import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';

const BillingSuccess = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg border border-gray-200 p-8 text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>

        {/* Success Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Subscription Activated!
        </h1>

        <p className="text-gray-600 mb-6">
          Your subscription is now active. You can start using the service immediately.
        </p>

        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-green-800">
            You will receive a confirmation email shortly with your invoice and subscription details.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Link
            to="/portal/billing"
            className="btn btn-primary w-full flex items-center justify-center gap-2"
          >
            Back to Billing
            <ArrowRight className="w-4 h-4" />
          </Link>

          <Link
            to="/portal"
            className="btn btn-outline w-full"
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BillingSuccess;
